import React from 'react'
import { COLORS } from '../../config';
import FieldWithEdit from '../../components/FieldItems/FieldWithEdit'
import ExclPointCircleIcon from '../../components/Icons/outline/ExclPointCircleIcon'

function CreditCardInputForm({
  setCardDetails,
  formError,
  cardDetails
}) {

  const addCardNumber = (e, type) => {
    let value = e.target.value;
    let lastValue = value[value.length - 1]
    if (isNaN(lastValue)) value = value.substring(0, value.length - 1);
    if (type === 1) {
      setCardDetails(prev => ({ ...prev, card_number: value }));
    } else {
      var x = e.target;
      var index = value.lastIndexOf("-");
      var test = value.substr(index + 1);
      if (test.length === 4 && value.length !== 19) x.value = value + "-";
    }
  };

  const addCardExpiryDate = (e, type) => {
    let value = e.target.value;
    let lastValue = value[value.length - 1]
    if (isNaN(lastValue)) value = value.substring(0, value.length - 1);
    if (type === 1) {
      setCardDetails((prev) => ({...prev, expiry_date: value }));
    } else {
      if (value.length === 2) {
        e.target.value = value + "/";
      }
    }
  };

  const addCVV = (e) => {
    let value = e.target.value;
    let lastValue = value[value.length - 1]
    if (isNaN(lastValue)) value = value.substring(0, value.length - 1);
    setCardDetails((prevState) => ({ ...prevState, cvv: value }))
  }

  return (
    <div id='card' className="w-full rounded bg-white shadow flex flex-col p-10 ">
      <div className='flex justify-between'>
      <h1 className="text-2xl text-secondary mb-10">Credit card information</h1>
      {formError.field === 'card' && 
      <span className="flex text-red-400 text-sm col-span-4">{formError.msg}{<ExclPointCircleIcon className='ml-2' stroke={COLORS.deleteRed}/>}</span>
      }
      </div>
      <div className='grid grid-cols-1 gap-y-4'>
        <FieldWithEdit 
          min="3"
          max="3" 
          label='CVV' 
          onChange={addCVV} 
          edit={true} 
          placeholder='411'
          data={cardDetails.cvv} 
          showEditIcon={false}  
          autocomplete='cc-csc'
        />
        <FieldWithEdit 
          label='Card number' 
          placeholder='4242-4242-4242-42424' 
          edit={true}     
          onChange={(e) => addCardNumber(e, 1)} 
          onKeyPress={(e) => addCardNumber(e, 2)}
          min="19" 
          max="19" 
          showEditIcon={false}
          data={cardDetails.card_number}
          autocomplete='cc-number'
        />
        <FieldWithEdit 
          label='NAME' 
          placeholder='Pierre Dupont' 
          onChange={(e) => setCardDetails((prevState) => ({ ...prevState, card_name: e.target.value }))} 
          edit={true}  
          min="1" 
          showEditIcon={false}  
          data={cardDetails.card_name}
          autocomplete='cc-name'
        />
        <FieldWithEdit 
          label='EXPIRY DATE' 
          placeholder='03/24' 
          onChange={(e) => addCardExpiryDate(e, 1)} 
          onKeyPress={(e) => addCardExpiryDate(e, 2)}
          edit={true} 
          min="5" 
          max="5" 
          showEditIcon={false} 
          data={cardDetails.expiry_date}
          autocomplete='cc-exp'
        />
      </div>
    </div>
  )
}

export default CreditCardInputForm
